import * as Yup from 'yup';

import { ALLOWED_CHARACTERS_REGEX, MAX_FILE_SIZE_5MB } from '@/common/constants';

export const invoiceInspectorSchema = (isDraft: boolean, savedOthersFileIds: string[] = [], isEdit = false, invoiceDownloadId = '', isReviewer = false) => {
    
    const validateOther = (otherNumber: number, message = `All fields in this other group are required if any is filled`) => {
        return Yup.string().test('all-or-none', message, function () {
            const { parent } = this;
            const other = parent[`other${otherNumber}`];
            const otherCost = parent[`otherCost${otherNumber}`];
            const otherCostFile = parent[`otherCostFile${otherNumber}`];
            const anyFilled = Boolean(other || otherCost || otherCostFile);
            const allFilled = Boolean(other && otherCost && (otherCostFile || savedOthersFileIds[otherNumber-1]));

            //console.log([otherNumber, other, otherCost, otherCostFile])

            if (!anyFilled) return true;
            return allFilled;
        });
    };

    return (
        Yup.object({
            sireType: isReviewer ? Yup.string()
                .trim()
                .required('SIRE type is required') :
                Yup.string().nullable(),
            invoiceNumber: Yup.string()
                .trim()
                .required('Invoice number is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            shipName: Yup.string()
                .trim()
                .required('Ship name is required'),
            invoiceDate: Yup.date()
                .required('Invoice date is required')
                .when('inspectionDate', (inspectionDate, schema) => (schema.min(inspectionDate, 'Invoice date cannot be earlier than inspection date'))),
            inspectionDate: Yup.date()
                .required('Inspection date is required'),
            country: Yup.string()
                .required('Country is required'),
            port: Yup.string()
                .trim()
                .required('Port is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            jobDescription: Yup.string()
                .trim()
                .required('Job description is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(255, 'Max length is 255 characters'),
            currency: Yup.string().required('Currency is required'),
            costInspection: Yup.string()
                .required('Cost inspection is required'),
            other1: (isDraft) ? Yup.string().nullable() : validateOther(1),
            otherCost1: (isDraft) ? Yup.string().nullable() : validateOther(1),
            otherCostFile1: validateOther(1),
            other2: (isDraft) ? Yup.string().nullable() : validateOther(2),
            otherCost2: (isDraft) ? Yup.string().nullable() : validateOther(2),
            otherCostFile2: validateOther(2),
            other3: (isDraft) ? Yup.string().nullable() : validateOther(3),
            otherCost3: (isDraft) ? Yup.string().nullable() : validateOther(3),
            otherCostFile3: validateOther(3),
            other4: (isDraft) ? Yup.string().nullable() : validateOther(4),
            otherCost4: (isDraft) ? Yup.string().nullable() : validateOther(4),
            otherCostFile4: validateOther(4),
            other5: (isDraft) ? Yup.string().nullable() : validateOther(5),
            otherCost5: (isDraft) ? Yup.string().nullable() : validateOther(5),
            otherCostFile5: validateOther(5),
            other6: (isDraft) ? Yup.string().nullable() : validateOther(6),
            otherCost6: (isDraft) ? Yup.string().nullable() : validateOther(6),
            otherCostFile6: validateOther(6),
            other7: (isDraft) ? Yup.string().nullable() : validateOther(7),
            otherCost7: (isDraft) ? Yup.string().nullable() : validateOther(7),
            otherCostFile7: validateOther(7),
            other8: (isDraft) ? Yup.string().nullable() : validateOther(8),
            otherCost8: (isDraft) ? Yup.string().nullable() : validateOther(8),
            otherCostFile8: validateOther(8),
            other9: (isDraft) ? Yup.string().nullable() : validateOther(9),
            otherCost9: (isDraft) ? Yup.string().nullable() : validateOther(9),
            otherCostFile9: validateOther(9),
            other10: (isDraft) ? Yup.string().nullable() : validateOther(10),
            otherCost10: (isDraft) ? Yup.string().nullable() : validateOther(10),
            otherCostFile10: validateOther(10),
            files: (!isEdit && isDraft) || (isEdit && isDraft) || (isEdit && invoiceDownloadId) ? Yup.mixed().nullable() : Yup.array()
                .of(Yup.mixed())
                .test('files', 'File size is too large', (value: any) => {
                    if (value && value.length > 0) {
                        return value.every((file: any) => file.size <= MAX_FILE_SIZE_5MB);
                    }

                    return false;
                })
                .required('Invoice file is required'),
            inspectionResultFile: Yup.mixed()
                .nullable()
                .test('fileSize', 'File size is too large', (value) => {
                    if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                        return false;
                    }
                    return true;
                }),
        }));
}
